import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { FormTranslatorService } from "../infrastructure/services/formTranslator.impl.service";
export const useFormTranslator = (formType = "PDD") => {
    const { i18n } = useTranslation();
    const lang = i18n.language;
    return useMemo(() => new FormTranslatorService(lang, formType), [lang, formType]);
};
